module.exports = __webpack_public_path__ + "static/media/003-user.9bb5b622.svg";